@if (creditorBankAccountDetailsWidgetData && initialized) {
    <mvs-widget [widgetData]="creditorBankAccountDetailsWidgetData">
    </mvs-widget>
}